<template>
<ItpPage
  :size="size"
  :header="documentTitle"
  :loaded="loaded"
  :noShow="!loaded"
  :modal="modal"
  itp-cname="BillingListItem"
  :modalBindings="b_7315092382398562_modalBindings"
  @close="evh_7315092382398562_close($event, {})"
>
  <UcHeader
    :card="!modal"
    :modal="modal"
    :color="$config.billingList.color"
    slot="header"
    v-if="loaded"
    @close="evh_2248226175642056_close($event, {})"
  >
    <UcBillingListItemHeader
      :item="resource"
      @reload="evh_8564662037462133_reload($event, {})"
      @deleted="evh_8564662037462133_deleted($event, {})"
    >
    </UcBillingListItemHeader>
  </UcHeader>
  <UcBody
    :card="!modal"
    :modal="modal"
    v-if="loaded"
  >
    <ItpForm
      :id="formId"
      :name="formName"
      :readonly="resource.isReadOnly"
      ref="mainForm"
      @submit="evh_1040167445267876_submit($event, {})"
    >
      <FieldsetBillingListItem
        :item="editor"
        :form="forms[formName]"
        @reload="evh_5534025912102772_reload($event, {})"
        @close="evh_5534025912102772_close($event, {})"
        @changed="evh_5534025912102772_changed($event, {})"
      >
      </FieldsetBillingListItem>
    </ItpForm>
  </UcBody>
  <UcFooter
    :card="!modal"
    :modal="modal"
    :color="$config.register.color"
    slot="footer"
    v-if="loaded"
  >
    <ItpBox
      class="ml-auto"
    >
      <ItpButton
        :form="forms[formName]"
        :text="'Create item'|pgettext('BillingListItem/Button')"
        type="submit"
        :spinning="actions.save.isRunning"
        class="mr-2"
        v-if="resource.isNew"
      >
      </ItpButton>
      <ItpButton
        :form="formId"
        :text="'Save changes'|pgettext('Button')"
        type="submit"
        :spinning="actions.save.isRunning"
        class="mr-2"
        v-if="!resource.isNew && !resource.isReadOnly && forms[formName]"
      >
      </ItpButton>
      <ItpButton
        :text="'Close'|gettext"
        variant="default"
        @click.prevent.stop="evh_2167826738365259_clickPreventStop($event, {})"
      >
      </ItpButton>
    </ItpBox>
  </UcFooter>
  <template
    slot="footer"
    v-if="loaded"
  >
  </template>
</ItpPage>
</template>

<script lang="ts">

import * as _ from 'lodash';
import Big from 'big.js';
import { Vue, Component, Watch, Prop } from 'vue-property-decorator';
import { mixins } from 'vue-class-component';
import {
  addRoute, UserComponentMixin, ComponentValueCache, actions
} from '@integro/core';

@Component()
export default class BillingListItem extends mixins(UserComponentMixin) {
  componentMetadata = {
    kind: "page",
  };

  beforeCreate() {
  }

  getContainer(...args: any[]) {
    return {
      self: this.$fn.urlFor('create_billing_list_item'),
      object: 'list',
      data: []
    }
  }

  getPayload(...args: any[]) {
    const [editor] = args;
    const exclude = [];

    return editor.isNew ?
      editor.getData({ exclude }) :
      editor.getChanges({ exclude, skipEmbeddedLists: true })
  }

  @Prop({
    type: String,
  })
  oid!: string;

  @Watch('oid')
  onOid(newValue: any, oldValue: any) {
    if (_.isEqual(newValue, oldValue)) return;
    this.loadDataThrottled("oid")
  }

  @Prop({
    type: Object,
  })
  templateParams!: object;

  @Watch('templateParams')
  onTemplate_params(newValue: any, oldValue: any) {
    if (_.isEqual(newValue, oldValue)) return;
    this.loadDataThrottled("templateParams")
  }

  @Prop({
    type: String,
    default: "lg",
  })
  size!: string;

  @Watch('size')
  onSize(newValue: any, oldValue: any) {
    if (_.isEqual(newValue, oldValue)) return;
    this.loadDataThrottled("size")
  }

  formId!: any;

  async $$load_formId() {
    return this.$fn.randomElementId()
  }

  formName!: any;
  messages!: any;
  resource!: any;

  async $$load_resource() {
    return this.oid
      ? this.$fn.fetch('read_billing_list_item', { parameters: { id: this.oid }, asResource: true })
      : this.$fn.fetch('get_billing_list_item_template', { parameters: this.templateParams, asResource: true })
  }

  editor!: any;

  async $$load_editor() {
    return this.resource.editor()
  }

  ux!: any;
  b_7315092382398562_modalBindings!: any;
  dataMembers = ['formId', 'formName', 'messages', 'resource', 'editor', 'ux', 'b_7315092382398562_modalBindings'];

  data() {
    return {
      ...this.mixinData(),
      actions: this.getActions(),
      ...{
        formId: null,
        formName: "billingListItem",
        messages: {
          createTitle: this.$fn.pgettext("BillingListItem", "New billing list item"),
        }
        ,
        resource: null,
        editor: null,
        ux: null,
        b_7315092382398562_modalBindings: {
          size: "lg",
        }
        ,
      },
    }
  }

  get isDeletable() {
    if (this.loaded) {

      return this.oid != null
    }
    return null;
  }

  get editTitle() {
    if (this.loaded) {

      return this.resource.description
    }
    return null;
  }

  get document() {
    if (this.loaded) {

      return {
        title: this.resource.isNew ? this.messages.createTitle : this.messages.editTitle,
      }
    }
    return null;
  }

  async act_7315092382398562_closeModal_2050_getActionArgs($event: actions.ActionEvent): Promise<actions.CloseModalActionArgs> {
    // parameterResolver name=act_7315092382398562_closeModal_2050, alias=undefined
    return {
      name: this.modalName,
      result: {
        close: true,
        cancel: true,
      }
      ,
    }
  }

  async evh_7315092382398562_close(event: Event, scope: Dictionary<any>) {
    return await this.actions.evh_7315092382398562_close.executeFromDOM(this, event, scope);
  }

  async evh_2248226175642056_close(event: Event, scope: Dictionary<any>) {
    return await this.actions.evh_2248226175642056_close.executeFromDOM(this, event, scope);
  }

  async evh_8564662037462133_reload(event: Event, scope: Dictionary<any>) {
    return await this.actions.evh_8564662037462133_reload.executeFromDOM(this, event, scope);
  }

  async act_8564662037462133_reloadSlickgrid_2058_getActionArgs($event: actions.ActionEvent): Promise<actions.ReloadSlickgridActionArgs> {
    // parameterResolver name=act_8564662037462133_reloadSlickgrid_2058, alias=undefined
    return {
      grid: "billingListItem",
    }
  }

  async evh_8564662037462133_deleted(event: Event, scope: Dictionary<any>) {
    return await this.actions.evh_8564662037462133_deleted.executeFromDOM(this, event, scope);
  }

  async act_1040167445267876_emit_2062_getActionArgs($event: actions.ActionEvent): Promise<actions.EmitActionArgs> {
    // parameterResolver name=act_1040167445267876_emit_2062, alias=undefined
    return {
      event: "saved",
      value: $event.data,
    }
  }

  async act_1040167445267876_closeComponent_2064_getActionArgs($event: actions.ActionEvent): Promise<actions.CloseComponentActionArgs> {
    // parameterResolver name=act_1040167445267876_closeComponent_2064, alias=undefined
    return {
      result: {
        ok: true,
        value: $event.data,
      }
      ,
    }
  }

  async act_1040167445267876_rest_2060_getActionArgs($event: actions.ActionEvent): Promise<actions.RestActionArgs> {
    // parameterResolver name=act_1040167445267876_rest_2060, alias=save
    return {
      method: "save",
      container: this.getContainer(this.editor),
      resource: this.editor,
      data: this.getPayload(this.editor),
    }
  }

  async evh_1040167445267876_submit(event: Event, scope: Dictionary<any>) {
    return await this.actions.evh_1040167445267876_submit.executeFromDOM(this, event, scope);
  }

  async evh_5534025912102772_reload(event: Event, scope: Dictionary<any>) {
    return await this.actions.evh_5534025912102772_reload.executeFromDOM(this, event, scope);
  }

  async evh_5534025912102772_close(event: Event, scope: Dictionary<any>) {
    return await this.actions.evh_5534025912102772_close.executeFromDOM(this, event, scope);
  }

  async act_5534025912102772_emit_2070_getActionArgs($event: actions.ActionEvent): Promise<actions.EmitActionArgs> {
    // parameterResolver name=act_5534025912102772_emit_2070, alias=undefined
    return {
      event: "saved",
      value: $event.data,
    }
  }

  async evh_5534025912102772_changed(event: Event, scope: Dictionary<any>) {
    return await this.actions.evh_5534025912102772_changed.executeFromDOM(this, event, scope);
  }

  async evh_2167826738365259_clickPreventStop(event: Event, scope: Dictionary<any>) {
    return await this.actions.evh_2167826738365259_clickPreventStop.executeFromDOM(this, event, scope);
  }

  actions!: {
    act_7315092382398562_closeModal_2050: actions.CloseModalAction;
    evh_7315092382398562_close_2049: actions.EventHandlerImpl;
    evh_7315092382398562_close: actions.EventHandlerGroup;
    act_2248226175642056_closeComponent_2052: actions.CloseComponentAction;
    evh_2248226175642056_close_2051: actions.EventHandlerImpl;
    evh_2248226175642056_close: actions.EventHandlerGroup;
    act_8564662037462133_reloadComponentData_2054: actions.ReloadComponentDataAction;
    evh_8564662037462133_reload_2053: actions.EventHandlerImpl;
    evh_8564662037462133_reload: actions.EventHandlerGroup;
    act_8564662037462133_closeComponent_2056: actions.CloseComponentAction;
    evh_8564662037462133_deleted_2055: actions.EventHandlerImpl;
    act_8564662037462133_reloadSlickgrid_2058: actions.ReloadSlickgridAction;
    evh_8564662037462133_deleted_2057: actions.EventHandlerImpl;
    evh_8564662037462133_deleted: actions.EventHandlerGroup;
    act_1040167445267876_emit_2062: actions.EmitAction;
    evh_1040167445267876_saved_2061: actions.EventHandlerImpl;
    act_1040167445267876_closeComponent_2064: actions.CloseComponentAction;
    evh_1040167445267876_saved_2063: actions.EventHandlerImpl;
    act_1040167445267876_rest_2060: actions.RestAction;
    evh_1040167445267876_submit_2059: actions.EventHandlerImpl;
    evh_1040167445267876_submit: actions.EventHandlerGroup;
    act_5534025912102772_reloadComponentData_2066: actions.ReloadComponentDataAction;
    evh_5534025912102772_reload_2065: actions.EventHandlerImpl;
    evh_5534025912102772_reload: actions.EventHandlerGroup;
    act_5534025912102772_closeComponent_2068: actions.CloseComponentAction;
    evh_5534025912102772_close_2067: actions.EventHandlerImpl;
    evh_5534025912102772_close: actions.EventHandlerGroup;
    act_5534025912102772_emit_2070: actions.EmitAction;
    evh_5534025912102772_changed_2069: actions.EventHandlerImpl;
    evh_5534025912102772_changed: actions.EventHandlerGroup;
    act_2167826738365259_closeComponent_2072: actions.CloseComponentAction;
    evh_2167826738365259_clickPreventStop_2071: actions.EventHandlerImpl;
    evh_2167826738365259_clickPreventStop: actions.EventHandlerGroup;
  }

  getActions() {
    const act_7315092382398562_closeModal_2050 = new actions.CloseModalAction(
      {
        actionArgs: this.act_7315092382398562_closeModal_2050_getActionArgs,
        events: [],
      }
    );
    const evh_7315092382398562_close_2049 = new actions.EventHandlerImpl(
      {
        action: act_7315092382398562_closeModal_2050,
        event: "close",
        displayName: "closeModal",
      }
    );
    const evh_7315092382398562_close = new actions.EventHandlerGroup(
      {
        handlers: [evh_7315092382398562_close_2049],
      }
    );
    const act_2248226175642056_closeComponent_2052 = new actions.CloseComponentAction(
      {
        events: [],
      }
    );
    const evh_2248226175642056_close_2051 = new actions.EventHandlerImpl(
      {
        action: act_2248226175642056_closeComponent_2052,
        event: "close",
        displayName: "closeComponent",
      }
    );
    const evh_2248226175642056_close = new actions.EventHandlerGroup(
      {
        handlers: [evh_2248226175642056_close_2051],
      }
    );
    const act_8564662037462133_reloadComponentData_2054 = new actions.ReloadComponentDataAction(
      {
        events: [],
      }
    );
    const evh_8564662037462133_reload_2053 = new actions.EventHandlerImpl(
      {
        action: act_8564662037462133_reloadComponentData_2054,
        event: "reload",
        displayName: "reloadComponentData",
      }
    );
    const evh_8564662037462133_reload = new actions.EventHandlerGroup(
      {
        handlers: [evh_8564662037462133_reload_2053],
      }
    );
    const act_8564662037462133_closeComponent_2056 = new actions.CloseComponentAction(
      {
        events: [],
      }
    );
    const evh_8564662037462133_deleted_2055 = new actions.EventHandlerImpl(
      {
        action: act_8564662037462133_closeComponent_2056,
        event: "deleted",
        displayName: "closeComponent",
      }
    );
    const act_8564662037462133_reloadSlickgrid_2058 = new actions.ReloadSlickgridAction(
      {
        actionArgs: this.act_8564662037462133_reloadSlickgrid_2058_getActionArgs,
        events: [],
      }
    );
    const evh_8564662037462133_deleted_2057 = new actions.EventHandlerImpl(
      {
        action: act_8564662037462133_reloadSlickgrid_2058,
        event: "deleted",
        displayName: "reloadSlickgrid",
      }
    );
    const evh_8564662037462133_deleted = new actions.EventHandlerGroup(
      {
        handlers: [evh_8564662037462133_deleted_2055, evh_8564662037462133_deleted_2057],
      }
    );
    const act_1040167445267876_emit_2062 = new actions.EmitAction(
      {
        actionArgs: this.act_1040167445267876_emit_2062_getActionArgs,
        events: [],
      }
    );
    const evh_1040167445267876_saved_2061 = new actions.EventHandlerImpl(
      {
        action: act_1040167445267876_emit_2062,
        event: "saved",
        displayName: "emit",
      }
    );
    const act_1040167445267876_closeComponent_2064 = new actions.CloseComponentAction(
      {
        actionArgs: this.act_1040167445267876_closeComponent_2064_getActionArgs,
        events: [],
      }
    );
    const evh_1040167445267876_saved_2063 = new actions.EventHandlerImpl(
      {
        action: act_1040167445267876_closeComponent_2064,
        event: "saved",
        displayName: "closeComponent",
      }
    );
    const act_1040167445267876_rest_2060 = new actions.RestAction(
      {
        actionArgs: this.act_1040167445267876_rest_2060_getActionArgs,
        displayName: "save",
        events: [evh_1040167445267876_saved_2061, evh_1040167445267876_saved_2063],
      }
    );
    const evh_1040167445267876_submit_2059 = new actions.EventHandlerImpl(
      {
        action: act_1040167445267876_rest_2060,
        event: "submit",
        displayName: "save",
      }
    );
    const evh_1040167445267876_submit = new actions.EventHandlerGroup(
      {
        handlers: [evh_1040167445267876_submit_2059],
      }
    );
    const act_5534025912102772_reloadComponentData_2066 = new actions.ReloadComponentDataAction(
      {
        events: [],
      }
    );
    const evh_5534025912102772_reload_2065 = new actions.EventHandlerImpl(
      {
        action: act_5534025912102772_reloadComponentData_2066,
        event: "reload",
        displayName: "reloadComponentData",
      }
    );
    const evh_5534025912102772_reload = new actions.EventHandlerGroup(
      {
        handlers: [evh_5534025912102772_reload_2065],
      }
    );
    const act_5534025912102772_closeComponent_2068 = new actions.CloseComponentAction(
      {
        events: [],
      }
    );
    const evh_5534025912102772_close_2067 = new actions.EventHandlerImpl(
      {
        action: act_5534025912102772_closeComponent_2068,
        event: "close",
        displayName: "closeComponent",
      }
    );
    const evh_5534025912102772_close = new actions.EventHandlerGroup(
      {
        handlers: [evh_5534025912102772_close_2067],
      }
    );
    const act_5534025912102772_emit_2070 = new actions.EmitAction(
      {
        actionArgs: this.act_5534025912102772_emit_2070_getActionArgs,
        events: [],
      }
    );
    const evh_5534025912102772_changed_2069 = new actions.EventHandlerImpl(
      {
        action: act_5534025912102772_emit_2070,
        event: "changed",
        displayName: "emit",
      }
    );
    const evh_5534025912102772_changed = new actions.EventHandlerGroup(
      {
        handlers: [evh_5534025912102772_changed_2069],
      }
    );
    const act_2167826738365259_closeComponent_2072 = new actions.CloseComponentAction(
      {
        events: [],
      }
    );
    const evh_2167826738365259_clickPreventStop_2071 = new actions.EventHandlerImpl(
      {
        action: act_2167826738365259_closeComponent_2072,
        event: "click.prevent.stop",
        displayName: "closeComponent",
      }
    );
    const evh_2167826738365259_clickPreventStop = new actions.EventHandlerGroup(
      {
        handlers: [evh_2167826738365259_clickPreventStop_2071],
      }
    );
    return {
      act_7315092382398562_closeModal_2050,
      evh_7315092382398562_close_2049,
      evh_7315092382398562_close,
      act_2248226175642056_closeComponent_2052,
      evh_2248226175642056_close_2051,
      evh_2248226175642056_close,
      act_8564662037462133_reloadComponentData_2054,
      evh_8564662037462133_reload_2053,
      evh_8564662037462133_reload,
      act_8564662037462133_closeComponent_2056,
      evh_8564662037462133_deleted_2055,
      act_8564662037462133_reloadSlickgrid_2058,
      evh_8564662037462133_deleted_2057,
      evh_8564662037462133_deleted,
      act_1040167445267876_emit_2062,
      evh_1040167445267876_saved_2061,
      act_1040167445267876_closeComponent_2064,
      evh_1040167445267876_saved_2063,
      act_1040167445267876_rest_2060,
      evh_1040167445267876_submit_2059,
      evh_1040167445267876_submit,
      act_5534025912102772_reloadComponentData_2066,
      evh_5534025912102772_reload_2065,
      evh_5534025912102772_reload,
      act_5534025912102772_closeComponent_2068,
      evh_5534025912102772_close_2067,
      evh_5534025912102772_close,
      act_5534025912102772_emit_2070,
      evh_5534025912102772_changed_2069,
      evh_5534025912102772_changed,
      act_2167826738365259_closeComponent_2072,
      evh_2167826738365259_clickPreventStop_2071,
      evh_2167826738365259_clickPreventStop,
      save: act_1040167445267876_rest_2060,
    }
  }
}

Vue.component("BillingListItem", BillingListItem);

</script>